import { render, staticRenderFns } from "./agencies.vue?vue&type=template&id=18499650&"
import script from "./agencies.vue?vue&type=script&lang=js&"
export * from "./agencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports